// Money is rounded and shown one way everywhere: two decimal places, standard
// rounding - a third decimal of 5 or more rounds the second up, anything less
// leaves it as it is:
//
//   1095.255  ->  1095.26
//   1095.254  ->  1095.25
//
// Floating point cannot hold most decimals exactly - 1095.255 is stored as
// 1095.25499999..., and sums and products pick up the same kind of noise - so
// plain toFixed(2) or Math.round(n * 100) rounded some halves down. The value
// is cut to 15 significant digits first, which drops that noise and nothing a
// user ever typed. The backend rounds the same way (services/fbrPayload.js).

const clean = (n) => Number(n.toPrecision(15));

// A half rounds away from zero, so -1.005 is -1.01 just as 1.005 is 1.01.
const hundredthsOf = (n) => {
  if (!Number.isFinite(n)) return 0;
  const hundredths = Math.round(clean(clean(Math.abs(n)) * 100));
  return n < 0 && hundredths ? -hundredths : hundredths;
};

// The two read a value the way the helpers they replaced did, so only the
// rounding changed: toHundredths with Number ("" -> 0), round2 with
// parseFloat ("12.5" and "12.5%" -> 12.5). Anything unreadable is 0.

/** The value in whole paisa (hundredths), rounded as above. */
export const toHundredths = (value) => hundredthsOf(Number(value));

/** The value rounded to two decimal places, as a number. */
export const round2 = (value) => hundredthsOf(parseFloat(value)) / 100;

/** The value rounded and written with exactly two decimals: "1095.20". */
export const formatTwoDecimals = (value) => round2(value).toFixed(2);

/** As formatTwoDecimals, with thousands separated: "1,095.20". */
export const formatMoney = (value) =>
  round2(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
